// extracted by mini-css-extract-plugin
export default {"shell":"TalentPageLayout_shell__IFBKI","content":"TalentPageLayout_content__AdfWx"};